import { defineApiMutation, defineApiQuery } from "utils/queries";
import { api, OnError, OnSuccess, protectedGet } from "./restUtil";

type TranslateProps = {
  targetLang: string;
  srcText: string;
  srcLang?: string;
};

type TranslationResponse = {
  input: string;
  translated_text: string;
};

export function translate(
  args: TranslateProps,
  onSuccess: OnSuccess<TranslationResponse>,
  onError?: OnError
) {
  const params = new URLSearchParams({
    text: args.srcText,
    target_lang: args.targetLang,
  });
  if (args.srcLang) {
    params.append("source_lang", args.srcLang);
  }
  return protectedGet("/google/translation", params.toString(), onSuccess, onError);
}

export type TranslationQueryParams = {
  text: string;
  source_lang?: string;
  target_lang: string;
};

export const translatedTextQuery = defineApiQuery<
  TranslationResponse,
  TranslationQueryParams
>({
  key: "/google/translation",
  // Paid Google call: a failed translation must not be retried automatically.
  retry: false,
});

// Imperative counterpart for button-triggered translation.
export const translateTextMutation = defineApiMutation<
  TranslationResponse,
  TranslationQueryParams
>({
  path: "/google/translation",
  mutationFn: (path, params) => api.get(path, params),
});

export const MAX_TRANSLATION_LENGTH = 5000;
